var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIndividual5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.74,
    height: 30,
    viewBox: "0 0 29.74 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#7097f6;}.d{fill:#1855f1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 29.74,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M27.718,27.951v-3.6a.658.658,0,0,0-1.315,0v3.6a1.537,1.537,0,0,0-.91,1.4,1.568,1.568,0,1,0,2.225-1.4m-.658,1.7a.3.3,0,1,1,.3-.3.324.324,0,0,1-.3.3",
    transform: "translate(-12.746 -11.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M24.986,8.7l.152-.25a2.2,2.2,0,0,0-3.54-2.6l-.2.3a13.883,13.883,0,0,0-3.187-1V3.7h.658a1.91,1.91,0,0,0,1.922-1.9A1.873,1.873,0,0,0,18.815,0H13.15a1.91,1.91,0,0,0-1.922,1.9A1.91,1.91,0,0,0,13.15,3.8h.658V5.25a14.038,14.038,0,0,0-4.2,1.5L9.256,6a.671.671,0,0,0-.86-.3.657.657,0,0,0-.3.85l.455.9A12.235,12.235,0,0,0,3.338,17.5a12.646,12.646,0,0,0,25.29,0,12.461,12.461,0,0,0-3.642-8.8M22.507,6.8l.1-.15a.921.921,0,0,1,1.315-.2.941.941,0,0,1,.2,1.3l-.1.1A13.764,13.764,0,0,0,22.507,6.8M12.493,1.9a.666.666,0,0,1,.657-.65h5.716a.666.666,0,0,1,.657.65.666.666,0,0,1-.657.65H13.15a.746.746,0,0,1-.657-.65m3.49,26.85a11.243,11.243,0,0,1-1.517-22.4.642.642,0,0,0,.556-.6v-2h1.922v2a.6.6,0,0,0,.556.6,11.243,11.243,0,0,1-1.517,22.4",
    transform: "translate(-1.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.922,50a1.9,1.9,0,1,0,0,3.8,1.9,1.9,0,1,0,0-3.8m0,2.5a.65.65,0,1,1,.657-.65.666.666,0,0,1-.657.65",
    transform: "translate(0 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M52.8,3.8A2.232,2.232,0,0,0,50.579,6,2.226,2.226,0,0,0,55.03,6,2.232,2.232,0,0,0,52.8,3.8m0,3.1a.955.955,0,0,1-.961-.95.961.961,0,1,1,.961.95",
    transform: "translate(-25.289 -1.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M28.527,25.256a9.5,9.5,0,0,0-2.782-6.6c-.051-.05-.1-.15-.2-.2a9.866,9.866,0,0,0-13.757.1A9.632,9.632,0,0,0,8.9,25.406a9.745,9.745,0,0,0,9.762,9.651,9.964,9.964,0,0,0,6.828-2.75.4.4,0,0,0,.2-.2,9.652,9.652,0,0,0,2.782-6.6v-.1c.1-.1.1-.15.051-.15m-2.175.75h.91a8.249,8.249,0,0,1-2.023,4.85l-.657-.65a.646.646,0,0,0-.91,0,.628.628,0,0,0,0,.9l.658.65a8.278,8.278,0,0,1-4.957,2v-.9a.658.658,0,0,0-1.315,0v.9a8.446,8.446,0,0,1-4.906-2l.657-.65a.629.629,0,0,0,0-.9.646.646,0,0,0-.91,0l-.557.65a8.066,8.066,0,0,1-2.023-4.85h.91a.65.65,0,1,0,0-1.3h-.91a8.3,8.3,0,0,1,2.073-4.85l.658.65a.646.646,0,0,0,.91,0,.628.628,0,0,0,0-.9l-.657-.65a8.266,8.266,0,0,1,4.906-2v.9a.658.658,0,0,0,1.315,0v-.9a8.5,8.5,0,0,1,4.907,2.05l-.658.65a.629.629,0,0,0,0,.9.646.646,0,0,0,.911,0l.657-.65a8.069,8.069,0,0,1,2.023,4.85h-.91a.666.666,0,0,0-.658.65.542.542,0,0,0,.556.6",
    transform: "translate(-4.451 -7.856)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.529,
    height: 1.25,
    transform: "translate(0.051 4.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.529,
    height: 1.25,
    transform: "translate(2.579 3.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.529,
    height: 1.25,
    transform: "translate(2.579 5.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.529,
    height: 1.25,
    transform: "translate(0.051 1.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.529,
    height: 1.25,
    transform: "translate(2.579 0.65)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndividual5);
export default __webpack_public_path__ + "static/media/Icon-individual-5.f4080f5d97f896e9364d08851d818039.svg";
export { ForwardRef as ReactComponent };